// src/hooks/useFeaturedBooks.js (for consistency)
import { useState, useEffect } from 'react';
import { db } from '../services/firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { useBooks } from './useBooks';

export const useFeaturedBooks = () => {
  const { books: allBooks, loading: booksLoading } = useBooks();
  const [featuredIds, setFeaturedIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const q = query(collection(db, 'featuredBooks'), orderBy('addedAt', 'desc'));
        const snapshot = await getDocs(q);
        const ids = snapshot.docs.map(doc => doc.data().bookId);
        setFeaturedIds(ids);
      } catch (error) {
        console.error('Error fetching featured books:', error);
        setFeaturedIds([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFeatured();
  }, []);

  const featuredBooks = allBooks
    .filter(book => featuredIds.includes(book.id))
    .sort((a, b) => featuredIds.indexOf(a.id) - featuredIds.indexOf(b.id));

  return { books: featuredBooks, loading: loading || booksLoading };
};